import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-downloads-folder-icon',
  templateUrl: './files-downloads-folder.component.html'
})
export class FilesDownloadsFolderComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
